import { useState, useCallback } from 'react'
import useHandleError from '../../../../hooks/useHandleError'
import { useFetchUserReportsData } from '../../../../hooks/useUserReportsData'
import { ReportInfo } from '../../../../types/ReportTypes'
import {
  fetchCompletionData,
  CompletionData,
  ButtonType,
} from '../../../../utils/completionQueries'

export function useCompletionData() {
  const [data, setData] = useState<CompletionData & { month: string }>()
  const [reportsData, setReportsData] = useState<Record<string, ReportInfo>>({})
  const [loading, setLoading] = useState(false)
  const handleError = useHandleError()
  const { fetchReportsData } = useFetchUserReportsData()

  const fetchCompletion = useCallback(
    async (
      month: string,
      selectedButton: ButtonType,
      includeAllRoles: boolean,
      selectedStudy: string | null
    ) => {
      setLoading(true)
      try {
        const completionData = await fetchCompletionData(
          month,
          selectedButton,
          includeAllRoles,
          selectedStudy
        )

        // Fetch reports data for all users
        const allUsers = [
          ...completionData.complete,
          ...completionData.incomplete,
        ]
        const reports = await fetchReportsData(allUsers)

        setData({ ...completionData, month })
        setReportsData(reports)
      } catch (e) {
        handleError(e)
      } finally {
        setLoading(false)
      }
    },
    [fetchReportsData, handleError]
  )

  return {
    data,
    reportsData,
    loading,
    fetchCompletion,
  }
}
